class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.viewport = this.querySelector(`#SliderViewport-${this.id}`);
    this.container = this.querySelector(`#SliderContainer-${this.id}`);
    this.slides = this.querySelectorAll(`[id^="Slide-${this.id}"]`);
    this.buttons = document.querySelector(`#SliderButtons-${this.id}`);
    this.prevButton = this.buttons
      ? this.buttons.querySelector('[name="previous"]')
      : null;
    this.nextButton = this.buttons
      ? this.buttons.querySelector('[name="next"]')
      : null;
    this.snapDisplay = this.querySelector(`#SliderSnapDisplay-${this.id}`);
    this.progress = this.querySelector(`#SliderProgress-${this.id}`);
    this.dots = this.querySelector(`#SliderDots-${this.id}`);
    this.dotNodes = [];
    this.sliderApi = null;
    this.altOptions = this.dataset.options
      ? JSON.parse(this.dataset.options)
      : {};
    this.options = {
      container: this.container,
      slides: this.slides,
      align: "start",
      slidesToScroll: 1,
      ...this.altOptions,
    };

    this.init();
  }

  init() {
    if (!window.EmblaCarousel) {
      return;
    }

    const sliderPlugins = [];
    if (this.dataset.autoscroll) {
      sliderPlugins.push(
        EmblaCarouselAutoScroll(JSON.parse(this.dataset.autoscroll))
      );
    }
    if (this.dataset.autoplay) {
      sliderPlugins.push(
        EmblaCarouselAutoplay(JSON.parse(this.dataset.autoplay))
      );
    }
    if (this.dataset.fade) {
      sliderPlugins.push(EmblaCarouselFade());
    }

    this.sliderApi = EmblaCarousel(this.viewport, this.options, sliderPlugins);
    this.registerEvents();
  }

  registerEvents() {
    /**
     * Slider Events
     * init,reInit,select,destroy,resize,scroll,settle,pointerDown,pointerUp
     */
    this.sliderApi
      .on("init", this.onSliderInit.bind(this))
      .on("reInit", this.onSliderReInit.bind(this))
      .on("select", this.onSliderSelect.bind(this));

    if (this.sliderApi.plugins().autoplay) {
      this.sliderApi
        .on("autoplay:timerset", this.startProgress.bind(this))
        .on("autoplay:timerstopped", this.stopProgress.bind(this));
    }

    return;
  }

  destroy() {
    if (!this.sliderApi) return;
    this.sliderApi.destroy();
  }

  reInit() {
    if (!this.sliderApi) return;
    this.sliderApi.reInit();
  }

  onSliderInit() {
    this.prevButton &&
      this.prevButton.addEventListener(
        "click",
        () => {
          this.sliderApi.scrollPrev();
        },
        false
      );
    this.nextButton &&
      this.nextButton.addEventListener(
        "click",
        () => {
          this.sliderApi.scrollNext();
        },
        false
      );
    if (this.dots) {
      this.dots.innerHTML = this.sliderApi
        .scrollSnapList()
        .map(() => `<span class="slider__dot"></span>`)
        .join("");
      this.dotNodes = Array.from(this.dots.querySelectorAll(".slider__dot"));
    }
    this.toggleButtonState();
    this.updateSnapDisplay();
    this.startProgress();
    this.toggleDotState();
  }

  onSliderReInit() {
    this.onSliderInit();
  }

  onSliderSelect() {
    this.updateSnapDisplay();
    this.toggleDotState();
    this.toggleButtonState();
  }

  scrollTo(index) {
    if (!this.sliderApi) return;
    this.sliderApi.scrollTo(index, true);
  }

  startProgress() {
    if (!this.progress) return;
    const autoplay = this.sliderApi.plugins().autoplay;
    if (!autoplay) return;
    const progressBar = this.progress.querySelector(".progress-bar");
    let animationName = "";
    let timeoutId = 0;
    let rafId = 0;
    const timeUntilNext = autoplay.timeUntilNext();
    if (timeUntilNext === null) return;
    if (!animationName) {
      const style = window.getComputedStyle(progressBar);
      animationName = style.animationName;
    }
    progressBar.style.animationName = "none";
    progressBar.style.transform = "translate3d(0,0,0)";
    rafId = window.requestAnimationFrame(() => {
      timeoutId = window.setTimeout(() => {
        progressBar.style.animationName = animationName;
        progressBar.style.animationDuration = `${timeUntilNext}ms`;
      }, 0);
    });
    this.progress.classList.remove("progress-hidden");
  }

  stopProgress() {
    if (!this.progress) return;
    const autoplay = this.sliderApi.plugins().autoplay;
    if (!autoplay) return;
    this.progress.classList.add("progress-hidden");
  }

  updateSnapDisplay() {
    if (!this.snapDisplay) return;
    const snapCount = this.sliderApi.scrollSnapList().length;
    if (snapCount === 1) return;
    const selectedSnap = this.sliderApi.selectedScrollSnap();
    this.snapDisplay.innerHTML = `${selectedSnap + 1} / ${snapCount}`;
  }

  toggleButtonState() {
    if (!this.sliderApi || !this.buttons) return;
    if (this.sliderApi.canScrollNext() || this.sliderApi.canScrollPrev()) {
      this.buttons.classList.add("is-enabled");
    } else {
      this.buttons.classList.remove("is-enabled");
    }

    if (this.prevButton) {
      if (this.sliderApi.canScrollPrev()) {
        this.prevButton.removeAttribute("disabled");
      } else {
        this.prevButton.setAttribute("disabled", "disabled");
      }
    }

    if (this.nextButton) {
      if (this.sliderApi.canScrollNext()) {
        this.nextButton.removeAttribute("disabled");
      } else {
        this.nextButton.setAttribute("disabled", "disabled");
      }
    }
  }

  toggleDotState() {
    if (!this.sliderApi || this.dotNodes.length < 1) return;
    const previous = this.sliderApi.previousScrollSnap();
    const selected = this.sliderApi.selectedScrollSnap();
    this.dotNodes[previous].classList.remove("active");
    this.dotNodes[selected].classList.add("active");
  }
}
customElements.define("slider-component", SliderComponent);
